export default __webpack_public_path__ + "static/media/F0006.a8346a1b.png";